import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { collectRoles, hasRole } from "../utils/roles";
import { apiUrl } from "../config/api";

export default function ObjectCard() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [obj, setObj] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(""); // оставлено для возможного будущего отображения, но пока не используется
  const token = (typeof window!=='undefined') ? (localStorage.getItem('authToken')||'') : '';
  const authHeaders = useMemo(() => (token? { Authorization: `Bearer ${token}` } : {}), [token]);
  const jsonHeaders = useMemo(() => ({ ...authHeaders, 'Content-Type': 'application/json' }), [authHeaders]);
  let user = null; let isSuper = false; let userRoles = [];
  try {
    user = JSON.parse(localStorage.getItem('authUser')||'null');
    isSuper = ['1001','1002'].includes(String(user?.id));
    userRoles = collectRoles(user);
  } catch {}
  const isAdmin = hasRole(userRoles, 'admin');

  // object managers state
  const [mgrHistory, setMgrHistory] = useState([]); // full history
  const [mgrLoading, setMgrLoading] = useState(false);
  const [users, setUsers] = useState([]); // for selection (only managers)
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ slot:1, manager_user_id:'', from_date:'', to_date:'' });
  const [closingId, setClosingId] = useState(null);
  const [closeDate, setCloseDate] = useState(()=> new Date().toISOString().slice(0,10));

  const canEditManagers = isSuper || isAdmin;

  useEffect(() => {
    setLoading(true);
    setError("");
    fetch(apiUrl(`/api/objects/${encodeURIComponent(id)}`), { headers: authHeaders })
      .then((r) => {
        if (r.status === 404) return null;
        return r.json();
      })
      .then((data) => {
        if (!data) setObj({ notFound: true });
        else setObj(data);
      })
      .catch(() => setError("Ошибка загрузки объекта"))
      .finally(() => setLoading(false));
  }, [authHeaders, id]);

  // load managers history & users list (admin/super only for users)
  useEffect(()=>{
    if (!id) return;
    setMgrLoading(true);
    fetch(apiUrl(`/api/object-managers/object/${encodeURIComponent(id)}`), { headers: authHeaders })
      .then(r=> r.ok? r.json(): [])
      .then(data=> setMgrHistory(Array.isArray(data)?data:[]))
      .catch(()=>{})
      .finally(()=> setMgrLoading(false));
    if (canEditManagers){
      fetch(apiUrl('/api/users'), { headers: authHeaders })
        .then(r=> r.ok? r.json(): [])
        .then(data=> setUsers(Array.isArray(data)? data.filter(u=> hasRole(u, 'manager')) : []))
        .catch(()=>{});
    }
  }, [authHeaders, canEditManagers, id]);

  const handleSave = () => {
    const body = {
      name: obj.name,
      address: obj.address ?? '',
      customer: obj.customer ?? '',
    };
    fetch(apiUrl(`/api/objects/${encodeURIComponent(id)}`), {
      method: "PATCH",
      headers: jsonHeaders,
      body: JSON.stringify(body),
    })
      .then((r) => {
        if (r.status === 409) throw new Error("Название занято");
        return r.json();
      })
      .then((saved) => setObj(saved))
      .catch((e) => alert("Ошибка сохранения: " + e.message));
  };

  function refreshManagers(){
    if (!id) return;
    setMgrLoading(true);
    fetch(apiUrl(`/api/object-managers/object/${encodeURIComponent(id)}`), { headers: authHeaders })
      .then(r=> r.ok? r.json(): [])
      .then(data=> setMgrHistory(Array.isArray(data)?data:[]))
      .catch(()=>{})
      .finally(()=> setMgrLoading(false));
  }

  function createManager(e){
    e.preventDefault();
    if (!canEditManagers) return;
    if (!form.slot || !form.manager_user_id || !form.from_date){ alert('Заполните слот, менеджера и дату начала'); return; }
    setCreating(true);
    fetch(apiUrl('/api/object-managers'), {
      method:'POST',
      headers: jsonHeaders,
      body: JSON.stringify({ object_id: Number(id), slot: Number(form.slot), manager_user_id: String(form.manager_user_id), from_date: form.from_date, to_date: form.to_date||undefined })
    }).then(r=> r.json().then(d=>({ ok:r.ok, data:d })))
      .then(({ok,data})=>{
        if (!ok){ alert('Ошибка добавления: '+(data?.error||'unknown')); }
        setForm({ slot:1, manager_user_id:'', from_date:'', to_date:'' });
        refreshManagers();
      })
      .catch(()=> alert('Сбой сети'))
      .finally(()=> setCreating(false));
  }

  function closeInterval(idToClose){
    if (!canEditManagers) return;
    if (!closeDate){ alert('Укажите дату закрытия'); return; }
    setClosingId(idToClose);
    fetch(apiUrl(`/api/object-managers/${idToClose}/close`), {
      method:'POST',
      headers: jsonHeaders,
      body: JSON.stringify({ to_date: closeDate })
    }).then(r=> r.json().then(d=>({ ok:r.ok, data:d })))
      .then(({ok,data})=> {
        if (!ok){ alert('Ошибка закрытия: '+(data?.error||'unknown')); }
        refreshManagers();
      })
      .catch(()=> alert('Сбой сети'))
      .finally(()=> setClosingId(null));
  }

  if (loading) return <div style={{ textAlign: "center", margin: 40 }}>Загрузка…</div>;
  if (obj?.notFound) return <div style={{ textAlign: "center", margin: 40, color: "#c00" }}>Объект не найден</div>;
  // простое отображение ошибки загрузки
  const errorBlock = error ? <div style={{ maxWidth:820, margin:'0 auto 16px', color:'#c00' }}>{error}</div> : null;

  return (
    <div style={{ padding: "32px 0 0 0" }}>
      {errorBlock}
      <div
        style={{
          background: "#fff",
          border: "1px solid #e6e8ef",
          borderRadius: 8,
          maxWidth: 820,
          margin: "0 auto",
          padding: 20,
          boxShadow: "0 2px 16px rgba(0,0,0,.08)",
        }}
      >
        <div style={{ fontSize: "1.35rem", marginBottom: 10 }}>
          Объект {String(obj.codeBase).padStart(4, "0")} — расчётов: {obj.calcCount}
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "160px 1fr", gap: 10, alignItems: "center" }}>
          <div>Название:</div>
          <input
            value={obj.name || ""}
            onChange={(e) => setObj((s) => ({ ...s, name: e.target.value }))}
            style={{ padding: "8px 10px" }}
          />

          <div>Адрес объекта:</div>
          <input
            value={obj.address || ""}
            onChange={(e) => setObj((s) => ({ ...s, address: e.target.value }))}
            style={{ padding: "8px 10px" }}
          />

          <div>Заказчик:</div>
          <input
            value={obj.customer || ""}
            onChange={(e) => setObj((s) => ({ ...s, customer: e.target.value }))}
            style={{ padding: "8px 10px" }}
          />

          {/* Период больше не редактируется у объекта */}
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16 }}>
          <button onClick={() => navigate(-1)}>Назад</button>
          <button onClick={handleSave} style={{ background: "#e7f6d4", border: "1px solid #8bc34a", padding: "8px 12px" }}>
            Сохранить
          </button>
        </div>
      </div>

      {/* Менеджеры объекта */}
      <div style={{ background:'#fff', border:'1px solid #e6e8ef', borderRadius:8, maxWidth: 980, margin:'24px auto', padding:20, boxShadow:'0 2px 16px rgba(0,0,0,.06)' }}>
        <div style={{ fontSize:'1.2rem', marginBottom:12, fontWeight:600 }}>Менеджеры объекта</div>
        {mgrLoading && <div style={{ marginBottom:10 }}>Загрузка менеджеров…</div>}
        {!mgrLoading && !mgrHistory.length && <div style={{ marginBottom:10 }}>История пока пустая</div>}
        {canEditManagers && (
          <form onSubmit={createManager} style={{ display:'flex', flexWrap:'wrap', gap:10, alignItems:'flex-end', marginBottom:20, background:'#fafafa', padding:'12px 12px', borderRadius:6 }}>
            <div style={{ display:'flex', flexDirection:'column' }}>
              <label>Слот</label>
              <select value={form.slot} onChange={e=> setForm(s=>({ ...s, slot: Number(e.target.value) }))} style={{ padding:'6px 8px' }}>
                <option value={1}>1</option>
                <option value={2}>2</option>
              </select>
            </div>
            <div style={{ display:'flex', flexDirection:'column', minWidth:220 }}>
              <label>Менеджер</label>
              <select value={form.manager_user_id} onChange={e=> setForm(s=>({ ...s, manager_user_id: e.target.value }))} style={{ padding:'6px 8px' }}>
                <option value="">— выбрать —</option>
                {users.map(u=> <option key={u.id} value={u.id}>{u.id} — {u.name}</option>)}
              </select>
            </div>
            <div style={{ display:'flex', flexDirection:'column' }}>
              <label>Дата начала</label>
              <input type="date" value={form.from_date} onChange={e=> setForm(s=>({ ...s, from_date: e.target.value }))} style={{ padding:'6px 8px' }} />
            </div>
            <div style={{ display:'flex', flexDirection:'column' }}>
              <label>Дата окончания (опц.)</label>
              <input type="date" value={form.to_date} onChange={e=> setForm(s=>({ ...s, to_date: e.target.value }))} style={{ padding:'6px 8px' }} />
            </div>
            <div style={{ display:'flex', flexDirection:'column' }}>
              <button disabled={creating} style={{ marginTop:22, background:'#e0f2ff', border:'1px solid #03a9f4', padding:'8px 14px', cursor:'pointer' }}>Добавить</button>
            </div>
          </form>
        )}
        {mgrHistory.length>0 && (
          <div style={{ overflowX:'auto' }}>
            <table style={{ borderCollapse:'collapse', width:'100%' }}>
              <thead>
                <tr style={{ background:'#f5f7fa' }}>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}>Слот</th>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}>Менеджер</th>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}>Период</th>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}>Действия</th>
                </tr>
              </thead>
              <tbody>
                {mgrHistory.map(row => {
                  const active = !row.to_date || (new Date(row.to_date) >= new Date());
                  return (
                    <tr key={row.id} style={{ background: active? '#fff' : '#fafafa' }}>
                      <td style={{ border:'1px solid #ebeef2', padding:'6px 8px', textAlign:'center' }}>{row.slot}</td>
                      <td style={{ border:'1px solid #ebeef2', padding:'6px 8px' }}>{(() => {
                        const u = users.find(x=> String(x.id)===String(row.manager_user_id));
                        return u ? `${row.manager_user_id} — ${u.name}` : row.manager_user_id;
                      })()}</td>
                      <td style={{ border:'1px solid #ebeef2', padding:'6px 8px' }}>{row.from_date} — {row.to_date? row.to_date : 'н.в.'}</td>
                      <td style={{ border:'1px solid #ebeef2', padding:'6px 8px' }}>
                        {canEditManagers && active && (!row.to_date) && (
                          <div style={{ display:'flex', gap:6, alignItems:'center' }}>
                            <input type="date" value={closeDate} onChange={e=> setCloseDate(e.target.value)} style={{ padding:'4px 6px' }} />
                            <button disabled={closingId===row.id} onClick={()=> closeInterval(row.id)} style={{ background:'#ffe9e0', border:'1px solid #ff9800', padding:'6px 10px', cursor:'pointer' }}>Закрыть</button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
